<script setup lang="ts">
import { markRaw } from 'vue'
import SuiviCommandesRepartition from '@/components/suivi-des-commandes/SuiviCommandesRepartition.vue'
import ListePropositions from '@/components/ListePropositions.vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import SuiviCommandesInfoCard from '@/components/suivi-des-commandes/SuiviCommandesInfoCard.vue'

const defaultComponents = [
  {
    id: 'info-card',
    component: markRaw(SuiviCommandesInfoCard),
  },
  {
    id: 'repartition-card',
    component: markRaw(SuiviCommandesRepartition),
  },
  {
    id: 'propositions-table',
    component: markRaw(ListePropositions),
  },
]

const { components } = useComponentOrder('suivi-des-commandes-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
